import WithHeaderAds from "../../Layout/WithHeaderAds";
import Footer from "../../Components/Footer";
import Styles from "./index.module.css";
import { Row, Col } from "react-bootstrap";

const SystemDesign = () => {
  return (
    <>
      <WithHeaderAds>
        <main className={Styles.homePage}>
          <ol>
            <li>
              <Row>
                <Col xs={12} sm={10}>
                  <p>
                    Implement a function that takes in a list of asynchronous
                    functions and executes the async functions in series. That
                    is, one at a time.
                  </p>
                </Col>
                <Col xs={12} sm={2}>
                  Answer
                </Col>
              </Row>
            </li>
            <li>
              <Row>
                <Col xs={12} sm={10}>
                  <p>
                    If you have multiple users making updates to the same
                    resource, how would you design a way to make sure the user
                    is updating the most up to date version? For example,
                    multiple people editing the same file document.
                  </p>
                </Col>
                <Col xs={12} sm={2}>
                  Answer
                </Col>
              </Row>
            </li>
          </ol>
        </main>
      </WithHeaderAds>
      <Footer />
    </>
  );
};

export default SystemDesign;
